export const DEFAULT_LESSON_REMINDERS = {
  enabled: true,
  channel: "email",
  firstLessonOnly: true,
  optedOutAt: null,
  lastSentAt: null,
};

export const DEFAULT_PAYMENT_REMINDERS = {
  enabled: true,
  channel: "email",
  optedOutAt: null,
  lastSentAt: null,
};

export function buildDefaultNewClientNotifications() {
  return {
    sendNotifications: true,
    lessonReminders: { ...DEFAULT_LESSON_REMINDERS },
    paymentReminders: { ...DEFAULT_PAYMENT_REMINDERS },
  };
}

export function normalizeLessonRemindersForForm(lessonReminders = {}, options = {}) {
  const defaultEnabled = typeof options.defaultEnabled === "boolean" ? options.defaultEnabled : false;
  return {
    ...DEFAULT_LESSON_REMINDERS,
    ...lessonReminders,
    channel: lessonReminders.channel || "email",
    enabled: typeof lessonReminders.enabled === "boolean" ? lessonReminders.enabled : defaultEnabled,
    firstLessonOnly: typeof lessonReminders.firstLessonOnly === "boolean" ? lessonReminders.firstLessonOnly : true,
    optedOutAt: lessonReminders.optedOutAt || null,
    lastSentAt: lessonReminders.lastSentAt || null,
  };
}

export function normalizePaymentRemindersForForm(paymentReminders = {}) {
  return {
    ...DEFAULT_PAYMENT_REMINDERS,
    ...paymentReminders,
    enabled: typeof paymentReminders.enabled === "boolean" ? paymentReminders.enabled : true,
    channel: paymentReminders.channel || DEFAULT_PAYMENT_REMINDERS.channel,
    optedOutAt: paymentReminders.optedOutAt || null,
    lastSentAt: paymentReminders.lastSentAt || null,
  };
}

export function updateLessonReminderPreference(client, field, value) {
  const lessonReminders = normalizeLessonRemindersForForm(client.lessonReminders, { defaultEnabled: !client.id });
  if (field === "restoreOptOut") {
    return {
      ...client,
      lessonReminders: {
        ...lessonReminders,
        enabled: true,
        firstLessonOnly: true,
        optedOutAt: null,
      },
    };
  }

  if (field === "preference") {
    return {
      ...client,
      lessonReminders: {
        ...lessonReminders,
        enabled: value !== "none",
        firstLessonOnly: value !== "all",
      },
    };
  }

  return {
    ...client,
    lessonReminders: {
      ...lessonReminders,
      [field]: value,
    },
  };
}

export function updatePaymentReminderPreference(client, field, value) {
  const paymentReminders = normalizePaymentRemindersForForm(client.paymentReminders);

  return {
    ...client,
    paymentReminders: {
      ...paymentReminders,
      [field]: value,
    },
  };
}
